import * as React from 'react';
import SettingsIcon from "@material-ui/icons/Settings";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Drawer from '@material-ui/core/Drawer/Drawer';

interface Props {
	className?: string;
}

const MobileSlideMenu: React.FC<Props> = props => {
	const [open, setOpen] = React.useState(false);

	return (
		<div className={props.className}>
			<IconButton onClick={() => setOpen(true)}>
				<SettingsIcon />
			</IconButton>

			<Drawer open={open} anchor="bottom" onClose={() => setOpen(false)}>
				{props.children}
			</Drawer>
		</div>
	);
};

export default MobileSlideMenu;